// Requires global jQuery + Slick loaded in theme.liquid

jQuery(function ($) {
  // Init Slick with fixed 3/2/1 slides
  $('.js-jw-love-track').slick({
    arrows: false,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: false,
    infinite: true,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 2 } },
      { breakpoint: 767,  settings: { 
        slidesToShow: 1,
         dots: true

       } }
    ]
  });

  // Arrow buttons inside the same wrapper as the track
  $('.js-jw-prev').on('click', function (e) {
    e.preventDefault();
    $(this).siblings('.js-jw-love-track').slick('slickPrev');
  });

  $('.js-jw-next').on('click', function (e) {
    e.preventDefault();
    $(this).siblings('.js-jw-love-track').slick('slickNext');
  });

  // Theme editor: init after section loads
  /*document.addEventListener('shopify:section:load', function (e) {
    var $sec = $(e.target);
    var $track = $sec.find('.js-jw-love-track');
    if ($track.length && !$track.hasClass('slick-initialized')) {
      $track.slick({
        arrows: false,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: false,
        infinite: true,
        responsive: [
          { breakpoint: 1199, settings: { slidesToShow: 2 } },
          { breakpoint: 767,  settings: { slidesToShow: 1 } }
        ]
      });
    }
  });*/
});
